module.exports = __webpack_public_path__ + "static/media/share-icon.124e3c00.svg";